import { Swiper, SwiperSlide } from 'swiper/react'

import { Autoplay } from 'swiper/modules'

import SwiperCore from 'swiper'

import { useEffect, useRef, useState } from 'react'

import 'swiper/css'

import { ICurrency } from '../../../store/fetchers/currencies'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { getCurrencies, fetchCurrencies } from '../../../store/reducers/currencies'
import { fetchWalletsPrices } from '../../../store/reducers/rates'
import {
  selectedWallets,
  selectedAvailableWallets,
  fetchWallets,
  fetchAvailableWallets,
} from '../../../store/reducers/wallets'

import styles from './styles.module.scss'
import ExchangePair from './exchange-pair'

export interface ICurrencyPair {
  currencyFrom: ICurrency
  currencyTo: ICurrency
}

export function ExchangePairs({ toCurrency }) {
  SwiperCore.use([Autoplay])
  const dispatch = useAppDispatch()

  const [availableCurrencies, setAvailableCurrencies] = useState<ICurrency[]>([])

  const currencies = useAppSelector(getCurrencies)
  const wallets = useAppSelector(selectedWallets)
  const availableWallets = useAppSelector(selectedAvailableWallets)
  const [topPairs, setTopPairs] = useState<ICurrencyPair[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const loaded = useRef(null)
  const [firstFetched, setFirstFetched] = useState<boolean>(true)
  const [firstFetchedWallets, setFirstFetchedWallets] = useState<boolean>(true)

  const swiperAutoPlay = useRef(null)

  useEffect(() => {
    if (currencies.length) {
      setAvailableCurrencies(currencies.filter((c) => c.is_allowed_for_wallet))
    }
  }, [currencies])

  useEffect(() => {
    if (availableCurrencies.length && !loaded.current) {
      constructPairs()
      loaded.current = true
    }
  }, [availableCurrencies])

  useEffect(() => {
    if (topPairs.length) {
      setIsLoading(false)
    }
  }, [topPairs])

  useEffect(() => {
    if (swiperAutoPlay.current) {
      const swiper = swiperAutoPlay.current.swiper
      if (isLoading) {
        swiper.autoplay.stop() // Остановить автовоспроизведение
      } else {
        swiper.autoplay.start() // Запустить автовоспроизведение
      }
    }
  }, [isLoading])

  const constructPairs = () => {
    const topPairs: ICurrencyPair[] = []
    for (const item of availableCurrencies) {
      if (
        item.code.toLowerCase() === toCurrency.ticker.toLowerCase() &&
        item.network.toLowerCase() === toCurrency.network.toLowerCase()
      ) {
        continue
      }
      const currencyPair: ICurrencyPair = {
        currencyFrom: item,
        currencyTo: availableCurrencies.find(
          (currency) =>
            currency.code.toLowerCase() === toCurrency.ticker.toLowerCase() &&
            currency.network.toLowerCase() === toCurrency.network.toLowerCase(),
        ),
      }
      if (currencyPair.currencyFrom && currencyPair.currencyTo) {
        topPairs.push(currencyPair)
      }
    }
    setTopPairs(topPairs)
  }

  //   const filterDiplicates = (arr: ICurrency[]): ICurrency[] => {
  //     const uniqueElements: { [key: string]: ICurrency } = {}

  //     for (const item of arr) {
  //       const { code, exchange_priority } = item

  //       const key = code

  //       if (key in uniqueElements) {
  //         if (exchange_priority < uniqueElements[key].exchange_priority) {
  //           uniqueElements[key] = item
  //         }
  //       } else {
  //         uniqueElements[key] = item
  //       }
  //     }

  //     const uniqueArr = Object.values(uniqueElements)
  //     return uniqueArr
  //   }

  useEffect(() => {
    if (firstFetched) {
      dispatch(fetchWalletsPrices())
      setFirstFetched(false)
    }
  }, [wallets])

  useEffect(() => {
    dispatch(fetchCurrencies())
    dispatch(fetchWallets())
  }, [dispatch])

  useEffect(() => {
    if (!availableWallets.length && firstFetchedWallets) {
      dispatch(fetchAvailableWallets())
      setFirstFetchedWallets(false)
    }
  }, [availableWallets])

  return (
    <>
      <section className={styles.cryptoAssets}>
        <div className={styles.cryptoAssets__main}>
          <div className={styles.cryptoAssets__main__row}>
            <Swiper
              spaceBetween={32}
              grabCursor={true}
              freeMode={false}
              slidesPerView={'auto'}
              loop={true}
              modules={[Autoplay]}
              speed={11000}
              autoplay={{ delay: 0, disableOnInteraction: false }}
            >
              {isLoading ? (
                <>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                </>
              ) : (
                topPairs.slice(0, topPairs.length / 3).map((currency) => (
                  <SwiperSlide
                    key={
                      currency.currencyFrom?.code +
                      currency.currencyFrom?.network +
                      currency.currencyTo?.code +
                      currency.currencyTo?.network
                    }
                  >
                    <ExchangePair currencyPair={currency} />
                  </SwiperSlide>
                ))
              )}
            </Swiper>
          </div>

          <div className={styles.cryptoAssets__main__row_second}>
            <Swiper
              spaceBetween={32}
              grabCursor={true}
              freeMode={false}
              slidesPerView={'auto'}
              loop={true}
              modules={[Autoplay]}
              speed={11000}
              autoplay={{ delay: 0, disableOnInteraction: false, reverseDirection: true }}
              ref={swiperAutoPlay}
            >
              {isLoading ? (
                <>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                </>
              ) : (
                topPairs.slice(topPairs.length / 3, (topPairs.length / 3) * 2 + 5).map((currency) => (
                  <SwiperSlide
                    key={
                      currency.currencyFrom?.code +
                      currency.currencyFrom?.network +
                      currency.currencyTo?.code +
                      currency.currencyTo?.network
                    }
                  >
                    <ExchangePair currencyPair={currency} />
                  </SwiperSlide>
                ))
              )}
            </Swiper>
          </div>

          <div className={styles.cryptoAssets__main__row}>
            <Swiper
              spaceBetween={32}
              grabCursor={true}
              freeMode={false}
              slidesPerView={'auto'}
              loop={true}
              modules={[Autoplay]}
              speed={11000}
              autoplay={{ delay: 0, disableOnInteraction: false }}
              breakpoints={{
                750: {
                  slidesPerView: 3,
                },
                950: {
                  slidesPerView: 4,
                },
                1500: {
                  slidesPerView: 5,
                },
                2150: {
                  slidesPerView: 6,
                },
              }}
            >
              {isLoading ? (
                <>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <ExchangePair isLoading={true} />
                  </SwiperSlide>
                </>
              ) : (
                topPairs.slice((topPairs.length / 3) * 2, topPairs.length).map((currency) => (
                  <SwiperSlide
                    key={
                      currency.currencyFrom?.code +
                      currency.currencyFrom?.network +
                      currency.currencyTo?.code +
                      currency.currencyTo?.network
                    }
                  >
                    <ExchangePair currencyPair={currency} />
                  </SwiperSlide>
                ))
              )}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  )
}
